import React from 'react';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const ParagraphUSPWrapper = ({ entity, containerless }) => {
  const title = entity.getIn(['field_title', 0, 'value']);
  const uspItems = entity.getIn(['field_usp_items']);

  return (
    <Container>
      <div className="row">
        <div className="col-md-10 col-sm-12 offset-md-1">
          <div className="ParagraphUSP__wrapper row">
            <div className="ParagraphUSP__header col-md-8 offset-md-2">
              {title && (
                <h3 className="ParagraphUSP__header__title">{title}</h3>
              )}
            </div>
            <Container>
              <div className="ParagraphUSP__items row">
                {
                  uspItems.map((uspItem) => {
                    const uspTitle = uspItem.getIn(['entity', 'field_title', 0, 'value']);
                    const uspBody = uspItem.getIn(['entity', 'field_body', 0, 'value']);
                    const uuid = uspItem.getIn(['entity', 'uuid', 0, 'value']);
                    return (
                      <div key={uuid} className="ParagraphUSP__item col-md-4 col-sm-12">
                        <div className="ParagraphUSP__item__title">
                          <h2>{uspTitle}</h2>
                        </div>
                        <div className="ParagraphUSP__item__body">
                          {uspBody}
                        </div>
                      </div>
                    );
                  })
                }
              </div>
            </Container>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ParagraphUSPWrapper;
